'use strict';

var React = require('react');

var SvgReportMinor = function SvgReportMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5h-11zm10.5 12h-2v-6h2v6zm-6 0h2v-9h-2v9zm-2 0h-2v-3h2v3z"
  }));
};

exports.SvgReportMinor = SvgReportMinor;
